/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const CubeIconConfig = {
  name: 'CubeIcon',
  height: 512,
  width: 512,
  svgPath: 'M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(CubeIconConfig);
//# sourceMappingURL=cube-icon.js.map